import { IOpportunity } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

export const getInitialOpportunitiesData = (): IOpportunity[] => [
  {
    TopDeal: 'List upcoming or current opportunities/deals',
    TotalUSD: 0,
    BusinessType: 'New Business',
    CloseDate: '',
  },
  {
    TopDeal: 'List deals further out in the future',
    TotalUSD: 0,
    BusinessType: 'Renewal',
    CloseDate: '',
  },
  { TopDeal: 'What are the Poly/HP Anywhere', TotalUSD: 0, BusinessType: '', CloseDate: '' },
]
